// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xmxrzkfrrvxrafnetjaj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhteHJ6a2ZycnZ4cmFmbmV0amFqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE2MDQ2NDAsImV4cCI6MjA1NzE4MDY0MH0.OLKMjRlhZx6WIJVIPa_hbJ6navQg6HKEOoKo_iaIbz4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);